import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { sellersApi, ApiError } from '../lib/api';

export default function SellerNew() {
  const nav = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const r = await sellersApi.create({
        login: login.trim(),
        password,
        display_name: displayName.trim() || null,
        contact_email: email.trim() || null,
        flowwow_token: token.trim() || null,
      });
      nav(`/sellers/${r.seller.id}`, { replace: true });
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) setErr('Логин уже занят');
      else if (e instanceof ApiError && e.status === 400) setErr('Проверь поля: ' + (e.message || ''));
      else setErr(String((e as Error)?.message ?? e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container narrow">
      <h2>Новый продавец</h2>
      <form className="card form" onSubmit={onSubmit}>
        <label>
          <span>Логин *</span>
          <input value={login} onChange={(e) => setLogin(e.target.value)} required autoFocus />
        </label>
        <label>
          <span>Пароль * (мин. 8 символов)</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
        </label>
        <label>
          <span>Имя для отображения</span>
          <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
        </label>
        <label>
          <span>Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>
          <span>Flowwow Bearer-токен</span>
          <textarea
            value={token}
            onChange={(e) => setToken(e.target.value)}
            rows={3}
            placeholder="eyJhbGciOi… (необязательно, можно добавить позже)"
          />
        </label>

        {err && <div className="error">{err}</div>}

        <div className="row">
          <button type="submit" className="btn primary" disabled={busy}>
            {busy ? 'Создаём…' : 'Создать'}
          </button>
          <button type="button" className="btn" onClick={() => nav('/sellers')}>Отмена</button>
        </div>
      </form>
    </div>
  );
}
